export default "__VITE_ASSET__DSKn3ap7__"